export const SmartSync_UpToDateSync = 'up-to-date';
export const SmartSync_DeltaSync = 'delta-sync';
export const SmartSync_FullSync = 'full';
//# sourceMappingURL=types.js.map